import React from 'react';

import Button from 'core/modules/atoms/Button';
import FormField from 'ui/molecules/form-field/FormField';
import InputText from 'ui/atoms/InputText/InputText';

const RecoverForm = () => {
  // deprecated
  return (
    <div className="login-form">
      <div className="login-form__item">
        <h3 className="login-form__title">Recover Password</h3>
      </div>
      <div className="login-form__item">
        <FormField label="Email">
          <InputText />
        </FormField>
      </div>
      <div className="login-form__item">
        <Button text="Recover Password" />
      </div>
    </div>
  );
};

export default RecoverForm;
